import { evaluateMath } from '../../util/arithmetic';

const convertibleUnits = [
  // 1 cup = 250ml
  { unit: 'cups', conversionFactor: 250, conversionUnit: 'ml' },
  { unit: 'cup', conversionFactor: 250, conversionUnit: 'ml' },
  { unit: 'tasses', conversionFactor: 250, conversionUnit: 'ml' },
  { unit: 'tasse', conversionFactor: 250, conversionUnit: 'ml' },
  // 1 lb = 453.59 g
  { unit: 'lbs', conversionFactor: 453.59, conversionUnit: 'g' },
  { unit: 'lb', conversionFactor: 453.59, conversionUnit: 'g' },
  // 1 tsp = 4.92892 ml
  { unit: 'tsp', conversionFactor: 4.92892, conversionUnit: 'ml' },
  { unit: 'teaspoons', conversionFactor: 4.92892, conversionUnit: 'ml' },
  { unit: 'teaspoon', conversionFactor: 4.92892, conversionUnit: 'ml' },
  { unit: 'cuillères à café', conversionFactor: 4.92892, conversionUnit: 'ml' },
  { unit: 'cuillère à café', conversionFactor: 4.92892, conversionUnit: 'ml' },
  // 1 tbsp = 14.7868 ml
  { unit: 'tbsp', conversionFactor: 14.7868, conversionUnit: 'ml' },
  { unit: 'tablespoons', conversionFactor: 14.7868, conversionUnit: 'ml' },
  { unit: 'tablespoon', conversionFactor: 14.7868, conversionUnit: 'ml' },
  { unit: 'cuillères à soupe', conversionFactor: 14.7868, conversionUnit: 'ml' },
  { unit: 'cuillère à soupe', conversionFactor: 14.7868, conversionUnit: 'ml' },
];

export default {
  init() {
    const ingredientLists = document.querySelectorAll('.ms-ingredients-list');
    this.startListener(ingredientLists);
  },
  startListener(ingredientLists) {
    const selector = {
      button: '.ms-ingredients-list__unit-toggle',
      ingredient: '.ms-ingredients-list__column-tabs li',
      list: '.ms-ingredients-list__column-tabs ul',
      tab: '.ms-ingredients-list__tab',
    }

    ingredientLists.forEach(ingredientList => {
      const buttons = ingredientList.querySelectorAll(selector.button);
      const imperialTab = ingredientList.querySelector(`${selector.tab}[data-unit="imperial"]`);
      const imperialIngredients = imperialTab.querySelectorAll(selector.ingredient);
      const lists = ingredientList.querySelectorAll(selector.list);
      const metricTab = ingredientList.querySelector(`${selector.tab}[data-unit="metric"]`);
      const metricIngredients = metricTab.querySelectorAll(selector.ingredient);
      const tabs = ingredientList.querySelectorAll(selector.tab);

      imperialIngredients.forEach((list, index) => {
        list.innerHTML = list.innerHTML.replace(/&nbsp;/g, ' '); // remove &nbsp;
        list.innerHTML = list.innerHTML.replace(/<\/?span[^>]*>/g, ' '); // remove span tag
        list.innerHTML = list.innerHTML.replace(/\s+/g,' ').trim(); // remove extra spacess

        if (list.innerHTML === '') {
          list.remove(); // remove empty li tag
          metricIngredients[index].remove();
          return;
        }

        const convertibleUnitsRegex = new RegExp(convertibleUnits.map(cu => cu.unit).join('|'), 'g');
        // will produce /\d+(\/\d+|\.\d+|\ \d+\/\d+)? (ml|g|cup|tasse)/g)
        const convertibleExpressionRegex = new RegExp('\\d+(\\/\\d+|\\.\\d+|\\-\\d+|\\ \\d+\\/\\d+)? (' + convertibleUnits.map(cu => cu.unit).join('|') + ')', 'g')

        const convertedIngredientStep = list.innerHTML.replace(convertibleExpressionRegex, conversionString => {
          // separate unit and value
          const value = conversionString.split(convertibleUnitsRegex)[0] || '';
          const unit = conversionString.match(convertibleUnitsRegex)[0] || '';

          const conversionMethod = convertibleUnits.find(cu => cu.unit === unit);
          if (!conversionMethod) return conversionString;

          const { conversionFactor, conversionUnit } = conversionMethod;

          // 1. split by range
          // 2. get the converted value
          // 3. rejoin to range
          const convertedValue = value.split('-').map(val => {
            const totalValue = val.split(' ').reduce((total, num) => total + evaluateMath(num), 0)
            return Number((totalValue * conversionFactor).toFixed(1));
          }).join('-');


          return `${convertedValue} ${conversionUnit}`;
        });

        metricIngredients[index].innerHTML = convertedIngredientStep;
      });

      buttons.forEach(button => {
        function handleTabVisibility(event) {
          const { target } = event;
          const dataTarget = target.dataset.target;
          const activeButton = Array.prototype.find.call(buttons, button => button.dataset.target === dataTarget);
          const activeTab = Array.prototype.find.call(tabs, tab => tab.dataset.unit === dataTarget);
          const previousActiveButton = Array.prototype.find.call(buttons, button => button.classList.contains('active'));
          const previousActiveTab = Array.prototype.find.call(tabs, tab => tab.classList.contains('active'));

          if (activeTab !== previousActiveTab) {
            activeTab.classList.add('active');
            previousActiveTab.classList.remove('active');
            activeButton.classList.add('active');
            previousActiveButton.classList.remove('active');
          }
        }

        button.addEventListener('click', e => handleTabVisibility(e));

        button.addEventListener('keyup', e => {
          const { keyCode } = e;

          if(keyCode === 39) {
            handleTabVisibility(e);
          } else if(keyCode === 37) {
            handleTabVisibility(e);
          }
        })
      });

      /* Initiate handleA11y function */
      this.handleA11y(buttons, ingredientList, lists);
    });
  },
  handleA11y(buttons, ingredientList, lists) {
    window.addEventListener('DOMContentLoaded', () => {
      // Set lists ARIA label
      lists.forEach(list => {
        const title = list.parentNode.previousElementSibling.textContent.trim();
        list.setAttribute('aria-label', title);
        list.setAttribute('role', 'list');
      });

      // Add a click event handler to each tab
      buttons.forEach(button => {
        button.addEventListener('click', changeTabs);
      });

      // Enable arrow navigation between tabs in the tab list
      let tabFocus = 0;

      ingredientList.addEventListener('keydown', e => {
        // Move right
        if (e.keyCode === 39 || e.keyCode === 37) {
          buttons[tabFocus].setAttribute('tabindex', -1);
          if (e.keyCode === 39) {
            tabFocus++;
            // If we're at the end, go to the start
            if (tabFocus >= buttons.length) {
              tabFocus = 0;
            }
            // Move left
          } else if (e.keyCode === 37) {
            tabFocus--;
            // If we're at the start, move to the end
            if (tabFocus < 0) {
              tabFocus = buttons.length - 1;
            }
          }

          buttons[tabFocus].setAttribute('tabindex', 0);
          buttons[tabFocus].focus();
        }
      });
    });

    function changeTabs(e) {
      const target = e.target;

      // Remove current selected tab
      ingredientList.querySelector('[aria-selected="true"]').setAttribute('aria-selected', false);

      // Set this tab as selected
      target.setAttribute('aria-selected', true);

      // Hide non-active tab panel
      ingredientList.querySelector('[role="tabpanel"]').setAttribute('hidden', true);

      // Show the selected panel
      ingredientList.querySelector(`#${target.getAttribute('aria-controls')}`).removeAttribute('hidden');
    }
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/ingredients-list.js